// Telegram API Client

import { BaseApiClient } from '../../../apiClients/BaseApiClient';
import {
  AvailableGroupsResponse,
  InvitationTokensResponse,
  LinkGroupResponse,
} from './types';

export class TelegramApiClient extends BaseApiClient {
  constructor() {
    super({ prefix: 'telegram' });
  }

  /**
   * Get all invitation tokens for the current workspace with bot information and link template
   * Access: Admin only (UserRole.Admin)
   */
  async getInvitationTokens(): Promise<InvitationTokensResponse> {
    return this.makeRequest<InvitationTokensResponse>('/invitation-tokens/');
  }

  /**
   * Get Telegram groups available for binding to the current workspace
   * Access: Admin only (UserRole.Admin)
   */
  async getAvailableGroups(): Promise<AvailableGroupsResponse> {
    return this.makeRequest<AvailableGroupsResponse>(
      '/groups/available-for-binding'
    );
  }

  /**
   * Link a Telegram group to the current workspace
   * Access: Admin only (UserRole.Admin)
   */
  async linkGroup(groupId: string): Promise<LinkGroupResponse> {
    return this.makeRequest<LinkGroupResponse>(`/groups/${groupId}/link`, {
      method: 'POST',
    });
  }
}

// Export singleton instance
export const telegramApi = new TelegramApiClient();
